import Model from '@/lib/data/Model';

class Auth extends Model {
    fields = [
        'email',
        'password',
        'confirm_password',
        'reset_password_token',
        'login_attempt_token',
        'id_token',
        'cell_phone',
        'company_name',
        'tz',
        'recaptcha',
    ];

    constructor(data) {
        super(data);
        this.init();
    }

    api = [
        {
            name: 'exchange',
            url: '/auth/exchange',
        },
        {
            name: 'loginAttempt',
            url: '/auth/exchange_login_attempt',
        },
        {
            name: 'signUp',
            url: '/auth/signup',
        },
        {
            name: 'resetPasswordRequest',
            url: '/auth/reset_password_request',
        },
        {
            name: 'resetPassword',
            url: '/auth/reset_password',
        },
        {
            name: 'generateQrCode',
            url: '/auth/generateQRcode',
        },
        {
            name: 'verifyCodeAndAuthorize',
            url: '/auth/verify_authorize',
            params: ['id, code'],
        },
    ];
}

export default Auth;
